// src/App.js
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { GoogleOAuthProvider } from "@react-oauth/google";

import Home from "./pages/Home";
import PoliticaPrivacidade from "./pages/Institucional/PoliticaPrivacidade";
import TermosUso from "./pages/Institucional/TermosUso";
import ErrorTest from "./pages/ErrorTest";

import BlogListing from "./pages/Blog/BlogListing";
import BlogPost from "./pages/Blog/BlogPost";

import PainelLayout from "./pages/Painel/PainelLayout";
import PainelAnalytics from "./pages/Painel/analytics/PainelAnalytics";
import PainelCRM from "./pages/Painel/crm/PainelCRM";
import PainelBlog from "./pages/Painel/blog/PainelBlog";
import PainelBlogForm from "./pages/Painel/blog/PainelBlogForm";
import PainelComentarios from "./pages/Painel/comentarios/PainelComentarios";
import PainelAgentes from "./pages/Painel/agentes/PainelAgentes";
import PainelIntegracoes from "./pages/Painel/integracoes/PainelIntegracoes";

import { AuthProvider } from "./context/AuthContext";
import CookieConsent from "./components/Consent/CookieConsent";
import usePageTracking from "./hooks/usePageTracking";

import "./App.css";
import "./styles/Button.css";

const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

// Dispara o tracking a cada mudança de rota (precisa estar dentro do Router).
function PageTracker() {
    usePageTracking();
    return null;
}

function App() {
    return (
        <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
        <AuthProvider>
            <PageTracker />
            <CookieConsent />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/blog" element={<BlogListing />} />
                <Route path="/blog/:slug" element={<BlogPost />} />

                <Route path="/painel" element={<PainelLayout />}>
                    <Route index element={<Navigate to="analytics" replace />} />
                    <Route path="analytics" element={<PainelAnalytics />} />
                    <Route path="crm" element={<PainelCRM />} />
                    <Route path="blog" element={<PainelBlog />} />
                    <Route path="blog/novo" element={<PainelBlogForm />} />
                    <Route path="blog/editar/:id" element={<PainelBlogForm />} />
                    <Route path="comentarios" element={<PainelComentarios />} />
                    <Route path="agentes" element={<PainelAgentes />} />
                    <Route path="integracoes" element={<PainelIntegracoes />} />
                </Route>

                {/* Compatibilidade com link antigo */}
                <Route path="/crm" element={<Navigate to="/painel/crm" replace />} />

                <Route path="/politica-de-privacidade" element={<PoliticaPrivacidade />} />
                <Route path="/termos-de-uso" element={<TermosUso />} />
                <Route path="/error-test" element={<ErrorTest />} />
            </Routes>
        </AuthProvider>
        </GoogleOAuthProvider>
    );
}

export default App;
